// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__31pL4","questions":"styles_questions__366zD","footer":"styles_footer__1owmB"};